/* eslint-disable react/jsx-pascal-case */
import { Col, DatePicker, ConfigProvider, Form, Input, Row, Button, Select, Space } from "antd";
import dayjs from 'dayjs';
import React, { useEffect, useState, useRef } from "react";
// import Label_language from '../../language'
import UploadImg from '../../utility/UploadImg'
import JoditEditor from "jodit-react";
const { ConfigContext } = ConfigProvider

const AppointmentForm = (
    {
        propsForm = null,
        formReloadCount = 0,
        onFormFinish = () => { },
    }
) => {
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [files, setFiles] = useState([])
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }
    const onChangeFileValue = (values) => {
        let file = values?.file ?? []
        setFiles(file)
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        // getNewsTypeOption()
        // getNewsWeightTypeOption()
    }
    const onFinish = (values) => {
        let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss")
        let announce_time_end = dayjs(values?.announce_time_end).format("YYYY-MM-DD HH:mm:ss")
        onFormFinish({
            ...values,
            news_time,
            announce_time_end
        })
        form.resetFields()
    }
    const onReset = () => {
        form.resetFields();
    };
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            console.log({ minutes })
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5)
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });
    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
        onChangeFileValue(formValues)
    }, [formReloadCount])

    return (
        <Row gutter={[10, 20]} justify="space-around" style={{ padding: "3vmin" }} >
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]} >
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"news_id"}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"姓名"}
                                name={"name"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>


                        <Col span={24}>
                            <Form.Item
                                label={"聯絡電話"}
                                name={"phone"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"電子信箱"}
                                name={"email"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"服務單位"}
                                name={"service_unit"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"內容"}
                                name={"content"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <TextArea rows={6} allowClear />
                            </Form.Item>
                        </Col>
                        {/* <Col>
                            <Form.Item
                                name={"file"}
                                initialValue={[]}
                                hidden={true}
                            >
                                <Input
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                        >
                            <Form.Item
                                label={"圖片"}
                            >
                                <UploadImg
                                    defaultValue={files}
                                    onImagesChange={(files) => {
                                        propsForm.setFieldValue({
                                            file: files
                                        })
                                        setFiles(files)
                                    }}
                                />
                            </Form.Item>
                        </Col> */}
                        <Col span={24}>
                            {/* <Form.Item> */}
                                <Row gutter={[8, 8]} justify="space-around">
                                <Col span={6} style={{ textAlign: 'end' }}>
                                </Col>
                                    <Col span={9} style={{ textAlign: 'end' }}>

                                        <Button htmlType="button" onClick={onReset} size="large">
                                            清除
                                        </Button>
                                    </Col>
                                    <Col span={9} style={{ textAlign: 'start' }}>
                                        <Button type="primary" htmlType="submit" size="large">
                                            送出
                                        </Button>
                                    </Col>
                                </Row>
                            {/* </Form.Item> */}
                        </Col>

                    </Row>
                </Form >
            </Col >
        </Row >
    )
}


export default AppointmentForm;
